import { lazy } from 'react';
import type { ToolConfig } from '@/types/tool';

export const jsonEditorConfig: ToolConfig = {
  id: 'json-editor',
  path: '/tools/json-editor',
  meta: {
    title: 'JSON Editor',
    description: 'Format, validate, and edit JSON with syntax highlighting. 100% client-side.',
    keywords: ['json', 'editor', 'formatter', 'validator', 'monaco'],
    icon: 'FileJson',
    category: 'data',
    gradient: 'from-emerald-500 to-teal-600',
  },
  component: lazy(() => import('./JsonEditor')),
};
